// Dependencies
import { FC } from "react";

// Styles
import {
  StyledTermHeader,
  StyledTermItem1,
  StyledTermItem2,
  StyledTermText,
  StyledTermsBackground,
  StyledTermsContent,
} from "./Terms.styled";

interface TermsProps {}

const Terms: FC<TermsProps> = () => {
  return (
    <StyledTermsBackground>
      <StyledTermsContent>
        <StyledTermHeader>Service Terms</StyledTermHeader>
        <StyledTermItem1>1. Introductions</StyledTermItem1>
        <StyledTermText>
          Các Điều khoản dịch vụ dành cho người dùng này ("Điều khoản") là giữa
          bạn ("bạn") và MLK. ("MLK" hoặc "chúng tôi") và chi phối việc bạn sử
          dụng tất cả các phiên bản phần mềm và dịch vụ của MLK, trang web của
          MLK.
        </StyledTermText>
        <StyledTermItem1>2. Binding Agreement</StyledTermItem1>
        <StyledTermText>
          Bằng cách tải xuống, cài đặt hoặc sử dụng Dịch vụ trên bất kỳ hệ thống
          máy tính, di động nào hoặc bằng cách chấp nhận các Điều khoản này
          (bằng cách nhấp vào hộp cho biết rằng bạn chấp nhận các Điều khoản này
          hoặc bằng cách thực hiện tài liệu đặt hàng (“Đơn đặt hàng”) tham chiếu
          đến các Điều khoản này), bạn thừa nhận và đồng ý rằng bạn đã đọc, hiểu
          và đồng ý các ràng buộc bởi các Điều khoản này và Chính sách quyền
          riêng tư của chúng tôi.
        </StyledTermText>
        <StyledTermText>
          Chúng tôi có quyền sửa đổi các Điều khoản này theo quyết định riêng
          của mình. Nếu MKL thực hiện bất kỳ thay đổi quan trọng nào đối với các
          Điều khoản này, chúng tôi có thể thông báo cho bạn qua email hoặc đăng
          thông báo trên Website . Nếu bạn không đồng ý hoặc không thể tuân thủ
          các Điều khoản đã sửa đổi, bạn phải ngừng sử dụng Dịch vụ và Trang
          web. Các Điều khoản được cập nhật sẽ có hiệu lực sau khi đăng và sẽ
          được áp dụng từ nay về sau, trừ khi có quy định khác trong thông báo
          gửi cho bạn. Việc bạn tiếp tục sử dụng Dịch vụ và Trang web sau bất kỳ
          cập nhật nào như vậy sẽ đồng nghĩa với việc bạn chấp nhận những thay
          đổi đó.
        </StyledTermText>
        <StyledTermText>
          Nếu bạn đồng ý với các Điều khoản này không phải với tư cách cá nhân
          mà thay mặt cho công ty, chính phủ hoặc tổ chức khác mà bạn đang đại
          diện (ví dụ: với tư cách là nhân viên hoặc quan chức chính phủ) thì
          "bạn" có nghĩa là tổ chức của bạn và bạn bị ràng buộc tổ chức của bạn
          tuân theo các Điều khoản này. Nếu bạn không có thẩm quyền đó hoặc nếu
          bạn không đồng ý với các Điều khoản này, thì không chấp nhận các Điều
          khoản này và không sử dụng Dịch vụ.
        </StyledTermText>
        <StyledTermText>
          Dịch vụ không dành cho bất kỳ ai dưới 3 tuổi và không nên sử dụng Dịch
          vụ của chúng tôi và chúng tôi không cho phép bất kỳ Người dùng nào
          dưới 3 tuổi sử dụng Dịch vụ của chúng tôi. Thuật ngữ “Người dùng” có
          nghĩa là bất kỳ cá nhân nào sử dụng Dịch vụ (như được định nghĩa trong
          Phần 3 bên dưới). Hơn nữa, bạn phải đảm bảo rằng tất cả Người dùng của
          bạn ít nhất phải ở độ tuổi trưởng thành nơi bạn cư trú để sử dụng Dịch
          vụ và/hoặc tham gia vào bất kỳ nghiên cứu nào.
        </StyledTermText>
        <StyledTermItem1>3. Use of Services</StyledTermItem1>
        <StyledTermItem2>3.1 Usage rights</StyledTermItem2>
        <StyledTermText>
          Tùy thuộc vào việc bạn tuân thủ các Điều khoản này và thanh toán các
          khoản phí áp dụng, MLK cấp cho bạn quyền có thể hủy bỏ, không độc
          quyền, không thể chuyển nhượng, không được cấp phép lại, có giới hạn
          để sử dụng* Dịch vụ trên cơ sở đăng ký ở dạng mã thực thi theo các
          Điều khoản này Điều kiện. Ngoại trừ các quyền hạn chế được quy định rõ
          ràng trong các Điều khoản này, MLK không cấp cho bạn giấy phép hoặc
          quyền nào khác trong Dịch vụ. Quyền của bạn sẽ chấm dứt khi các Điều
          khoản này bị chấm dứt ngay cả khi có các điều khoản trái ngược được
          quy định ở nơi khác trong các Điều khoản này hoặc trong tài liệu khác
          được ký kết giữa MLK và bạn.
        </StyledTermText>
        <StyledTermText>
          Sử dụng, Sử dụng hoặc Đã sử dụng có nghĩa là kích hoạt trực tiếp hoặc
          gián tiếp khả năng xử lý của Dịch vụ, tải, thực thi, truy cập, sử
          dụng, lưu trữ, sử dụng Dịch vụ hoặc hiển thị thông tin thu được từ các
          khả năng đó, bao gồm tải lên bất kỳ Nội dung nào * hoặc tạo hoặc tạo
          ra bất kỳ Nội dung nào Nội dung bằng cách sử dụng các khả năng của
          Dịch vụ.
        </StyledTermText>
        <StyledTermText>
          **Nội dung đề cập đến nội dung được nêu bật hoặc hiển thị thông qua
          Dịch vụ (bao gồm thông qua Trang web), bao gồm nhưng không giới hạn ở
          mã, văn bản, dữ liệu, bài viết, hình ảnh, ảnh chụp, đồ họa, phần mềm,
          ứng dụng, gói, thiết kế, tính năng và các tài liệu khác có sẵn trên
          Trang web hoặc có sẵn thông qua Dịch vụ. "Nội dung do người dùng tạo"
          là Nội dung, được viết hoặc bằng cách khác, mà Người dùng tải lên hoặc
          tạo bằng cách sử dụng Dịch vụ. "Nội dung của bạn" là Nội dung do Người
          dùng tạo mà bạn hoặc Người dùng của bạn gửi tới Dịch vụ.
        </StyledTermText>
        <StyledTermItem2>3.2 Accounts</StyledTermItem2>
        <StyledTermText>
          Dịch vụ cho phép Người dùng tạo một tài khoản cá nhân ("Tài khoản").
          Thông tin bạn cung cấp cho chúng tôi khi tạo Tài khoản phải chính xác,
          đầy đủ và cập nhật. Bạn cũng có nghĩa vụ luôn giữ thông tin Tài khoản
          của mình chính xác, đầy đủ và cập nhật. Nếu bất kỳ thông tin nào bạn
          gửi cho chúng tôi thay đổi, bạn phải cập nhật kịp thời thông tin đó.
        </StyledTermText>
        <StyledTermText>
          Bạn phải giữ thông tin đăng nhập Tài khoản của mình an toàn và bảo
          mật. Bạn chịu trách nhiệm về mọi hành động được thực hiện thông qua
          Tài khoản của mình. Bạn phải thông báo kịp thời cho MLK và sửa đổi
          thông tin đăng nhập Tài khoản của bạn hoặc thông tin đăng nhập của
          Người dùng được phép nếu thông tin đăng nhập đó bị xâm phạm và/hoặc sử
          dụng sai/có khả năng bị bên thứ ba sử dụng sai mục đích để truy cập
          Dịch vụ thông qua Tài khoản của bạn không đúng cách. Bạn cũng đồng ý
          rằng thông tin hồ sơ của bạn sẽ chính xác.
        </StyledTermText>
        <StyledTermItem1>4. Use of Content</StyledTermItem1>
        <StyledTermText>
          Bạn có thể tạo hoặc tải lên Nội dung do người dùng tạo trong khi sử
          dụng Dịch vụ. Bạn hoàn toàn chịu trách nhiệm về mọi Nội dung do người
          dùng tạo mà bạn đăng, tải lên, liên kết đến hoặc cung cấp thông qua
          Dịch vụ, bất kể hình thức của Nội dung đó. Bằng cách tải lên Nội dung
          do người dùng tạo trong khi sử dụng Dịch vụ, bạn tuyên bố và đảm bảo
          rằng bạn có tất cả các quyền cần thiết để gửi Nội dung do người dùng
          tạo và Nội dung do người dùng tạo là chính xác và không vi phạm bất kỳ
          quy định hiện hành nào. pháp luật, các hạn chế trong hợp đồng hoặc các
          quyền khác của bên thứ ba, bao gồm quyền sở hữu trí tuệ hoặc các quyền
          liên quan đến quyền riêng tư của bất kỳ cá nhân hoặc tổ chức nào. Bạn
          cũng đồng ý rằng thông tin hồ sơ của bạn sẽ chính xác. Chúng tôi không
          chịu trách nhiệm về bất kỳ việc hiển thị công khai hoặc sử dụng sai
          mục đích Nội dung do người dùng tạo của bạn.
        </StyledTermText>
        <StyledTermText>
          Chúng tôi có quyền từ chối hoặc xóa bất kỳ Nội dung nào, theo quyết
          định riêng của chúng tôi, vi phạm bất kỳ luật hoặc điều khoản hoặc
          chính sách nào của Người đưa thư.
        </StyledTermText>
        <StyledTermText>
          Bạn giữ quyền sở hữu và chịu trách nhiệm về Nội dung của mình. Vì bạn
          giữ quyền sở hữu và chịu trách nhiệm đối với Nội dung của mình nên
          chúng tôi cần bạn cấp cho chúng tôi —và những Người dùng khác— một số
          quyền pháp lý nhất định được liệt kê trong Phần 5.4 - 5.6. Các khoản
          cấp phép này áp dụng cho Nội dung của bạn. Bạn hiểu rằng bạn sẽ không
          nhận được bất kỳ khoản thanh toán nào cho bất kỳ quyền nào được cấp
          trong Mục 5.4 - 5.6. Giấy phép bạn cấp cho chúng tôi và Người dùng của
          chúng tôi sẽ kết thúc khi bạn xóa Nội dung của bạn khỏi máy chủ của
          chúng tôi, trừ khi những Người dùng khác đã phân nhánh nội dung đó,
          trong trường hợp đó, giấy phép sẽ tiếp tục cho đến khi tất cả Người
          dùng đó xóa Nội dung khỏi máy chủ của chúng tôi.
        </StyledTermText>
      </StyledTermsContent>
    </StyledTermsBackground>
  );
};

export default Terms;
